export const messages = {
    "wrh-dashboard.nav-menu.item.resources": "리소스",
    "wrh-dashboard.nav-menu.item.shared": "공유",
    "wrh-dashboard.nav-menu.item.backups": "백업",
    "wrh-dashboard.nav-menu.item.archives": "아카이브",
    "wrh-dashboard.nav-menu.item.sync": "동기화",
    "wrh-dashboard.nav-menu.item.mobile": "모바일",
    "wrh-dashboard.nav-menu.item.account": "계정",
    "wrh-dashboard.search.input.hint": "검색",
    "wrh-dashboard.search.label.breadcrumb": "검색 결과",
    "wrh-dashboard.search.message.empty": "검색과 일치하는 항목이 없습니다",
    "wrh-dashboard.side-bar.selected.title:plural": "{count}개 항목 선택됨 | {count}개 항목 선택됨",
    "wrh-dashboard.side-bar.backup-type.entire-pc": "전체 PC",
    "wrh-dashboard.side-bar.backup-type.entire-mac": "전체 Mac",
    "wrh-dashboard.side-bar.backup-type.disk": "디스크 및 파티션",
    "wrh-dashboard.side-bar.backup-type.file": "파일 및 폴더",
    "wrh-dashboard.side-bar.backup-type.notarized": "공증된 파일과 폴더",
    "wrh-dashboard.side-bar.backup-type.sync": "동기화",
    "wrh-dashboard.side-bar.backup-type.archiving": "아카이브",
    "wrh-dashboard.space-indicator.label.left": "{spaceFree} 남음",
    "wrh-dashboard.space-indicator.label.used": "{usedSpace} 사용됨",
    "wrh-dashboard.space-indicator.label.unlimited": "제한 없음",
    "wrh-dashboard.backups-table.column.name": "이름",
    "wrh-dashboard.backups-table.column.size": "크기",
    "wrh-dashboard.backups-table.column.version": "마지막 버전",
    "wrh-dashboard.backups-table.action.cleanup": "정리",
    "wrh-dashboard.backups-table.action.download-tool": "다운로드",
    "wrh-dashboard.backups-table.action.delete": "삭제",
    "wrh-dashboard.backups-table.action.downloads": "다운로드",
    "wrh-dashboard.backups-table.message.no-backups": "클라우드에 아직 백업이 없습니다",
    "wrh-dashboard.backups-table.message.no-archives": "클라우드에 아직 아카이브가 없습니다",
    "wrh-dashboard.backups-table.message.no-syncs": "클라우드에 아직 동기화가 없습니다",
    "wrh-dashboard.backups-sidebar.label.size": "크기",
    "wrh-dashboard.backups-sidebar.label.type": "유형",
    "wrh-dashboard.backups-sidebar.label.version": "마지막 버전",
    "wrh-dashboard.content-table.column.name": "이름",
    "wrh-dashboard.content-table.column.versions": "버전",
    "wrh-dashboard.content-table.column.volumes": "볼륨",
    "wrh-dashboard.content-table.column.path": "경로",
    "wrh-dashboard.content-table.column.size": "크기",
    "wrh-dashboard.content-table.column.version": "마지막 버전",
    "wrh-dashboard.content-table.action.notary-verify": "확인",
    "wrh-dashboard.content-table.action.notary-get-crt": "인증서 가져오기",
    "wrh-dashboard.content-table.action.asign": "서명을 위해 전송",
    "wrh-dashboard.content-table.action.versions": "버전",
    "wrh-dashboard.content-table.action.restore": "다운로드",
    "wrh-dashboard.content-table.action.share": "공유 링크",
    "wrh-dashboard.content-table.label.size": "크기",
    "wrh-dashboard.content-table.label.created": "생성됨",
    "wrh-dashboard.content-table.label.modified": "수정",
    "wrh-dashboard.content-table.message.empty-folder": "이 폴더가 비어 있습니다",
    "wrh-dashboard.password-dialog-box.title.backup": "암호화된 백업",
    "wrh-dashboard.password-dialog-box.title.archive": "암호화된 아카이브",
    "wrh-dashboard.password-dialog-box.message.backup": "백업 {displayName}에 액세스하기 위한 비밀번호를 지정하십시오",
    "wrh-dashboard.password-dialog-box.message.archive": "아카이브 {displayName}에 액세스하기 위한 비밀번호를 지정하십시오",
    "wrh-dashboard.password-dialog-box.hint.password": "암호",
    "wrh-dashboard.password-dialog-box.message.invalid-password": "비밀번호가 잘못되었습니다",
    "wrh-dashboard.download-tool-dialog-box.message.title": "클라우드 백업 다운로드",
    "wrh-dashboard.download-tool-dialog-box.message.first-header": "백업에서 파일 또는 폴더를 다운로드하려면:",
    "wrh-dashboard.download-tool-dialog-box.message.first-paragraph": "백업 이름을 클릭하고 백업 내의 파일이나 폴더를 선택한 다음 오른쪽 패널에서 '다운로드'를 클릭합니다.",
    "wrh-dashboard.download-tool-dialog-box.message.second-header": "전체 백업 또는 백업 세트를 다운로드하려면:",
    "wrh-dashboard.download-tool-dialog-box.message.second-paragraph": "{toolName}을(를) 사용합니다. 도구를 아직 다운로드하지 않았다면 다운로드해야 합니다.",
    "wrh-dashboard.download-tool-dialog-box.message.tool-name": "Acronis Cloud Backup Download 도구",
    "wrh-dashboard.download-tool-dialog-box.message": "도구 다운로드",
    "wrh-dashboard.download-tool-dialog-box.gotIt": "확인",
    "wrh-dashboard.form.button.open": "열기",
    "wrh-dashboard.form.button.close": "닫기",
    "wrh-dashboard.form.button.cancel": "취소",
    "wrh-dashboard.form.button.continue": "계속",
    "wrh-dashboard.form.button.proceed": "진행",
    "wrh-dashboard.form.button.delete": "삭제",
    "wrh-dashboard.form.button.done": "완료",
    "wrh-dashboard.form.button.retry": "재시도",
    "wrh-dashboard.form.button.go-to-backups": "백업으로 이동",
    "wrh-dashboard.delete-dialog-box.title.backup": "백업 삭제",
    "wrh-dashboard.delete-dialog-box.message.backup": "선택한 백업을 모든 위치에서 영구 삭제하시겠습니까? 백업의 모든 데이터가 없어지고 복구할 수 없습니다.",
    "wrh-dashboard.delete-dialog-box.title.archive": "아카이브 삭제",
    "wrh-dashboard.delete-dialog-box.message.archive": "선택한 아카이브를 모든 위치에서 영구 삭제하시겠습니까? 아카이브의 모든 데이터가 없어지고 복구할 수 없습니다.",
    "wrh-dashboard.delete-dialog-box.locked-error-message.backup": "데이터 일관성을 위해 백업이 잠겼습니다. 백업이 포함된 모든 작업(예: 찾아보기, 복원, 백업)을 종료하고 다시 시도하십시오.",
    "wrh-dashboard.delete-dialog-box.locked-error-message.archive": "데이터 일관성을 위해 아카이브가 잠겼습니다. 아카이브가 포함된 모든 작업(예: 찾아보기, 복원, 백업)을 종료하고 다시 시도하십시오.",
    "wrh-dashboard.cleanup-dialog-box.title": "{brandName} 정리",
    "wrh-dashboard.cleanup-dialog-box.checkbox.delete-versions-older-than": "다음보다 오래된 백업 버전 삭제",
    "wrh-dashboard.cleanup-dialog-box.checkbox.delete-all-versions-except": "다음을 제외한 모든 오래된 백업 버전 삭제",
    "wrh-dashboard.cleanup-dialog-box.checkbox.delete-all-versions-recent-ones": "최신 버전",
    "wrh-dashboard.cleanup-dialog-box.combobox.time-unit.days": "일",
    "wrh-dashboard.cleanup-dialog-box.combobox.time-unit.months": "월",
    "wrh-dashboard.cleanup-dialog-box.combobox.time-unit.years": "기간(년)",
    "wrh-dashboard.cleanup-dialog-box.button.cleanup-now": "지금 정리",
    "wrh-dashboard.cleanup-dialog-box.button.cleanup": "정리",
    "wrh-dashboard.cleanup-dialog-box.message": "{brandName}의 여유 공간 확보를 위해 일시적으로 오래된 백업 버전을 삭제할 수 있습니다. True Image 백업에 지정된 정리 설정에는 변경이 없습니다.",
    "wrh-dashboard.cleanup-dialog-box.message.cleanup-encrypted": "백업 중 {encryptedBackupCount} / {totalBackupCount}이(가) 암호화되었습니다. 이를 정리하려면 비밀번호를 입력해야 합니다. 별도로 정리하십시오.",
    "wrh-dashboard.cleanup-confirm-dialog-box.title": "정리",
    "wrh-dashboard.cleanup-confirm-dialog-box.message": "이 데이터를 삭제하시겠습니까? 작업을 실행 취소할 수 없습니다.",
    "wrh-dashboard.cleanup-encrypted-dialog-box.title": "{brandName} 정리",
    "wrh-dashboard.cleanup-encrypted-dialog-box.message": "암호화된 백업만 있습니다. 이를 정리하려면 비밀번호를 입력해야 합니다. 별도로 정리하십시오.",
    "wrh-dashboard.cleanup-progress-dialog-box.title": "정리",
    "wrh-dashboard.cleanup-progress-dialog-box.message": "정리 작업의 상태를 검토하려면 이 창을 열어두십시오. 창을 닫으면 정리 작업이 백그라운드 모드로 계속 진행됩니다.",
    "wrh-dashboard.cleanup-progress-dialog-box.status": "{displayName} 정리 중...",
    "wrh-dashboard.cleanup-notification-dialog-box.title": "정리",
    "wrh-dashboard.cleanup-notification-dialog-box.message.success": "정리가 완료되었습니다. 클라우드 사용량 정보를 업데이트하는 데 시간이 걸릴 수 있습니다.",
    "wrh-dashboard.cleanup-notification-dialog-box.message.fail": "정리 실패",
    "wrh-dashboard.cleanup-notification-dialog-box.message.box-locked": "백업을 진행하는 동안 정리를 수행할 수 없습니다. 나중에 다시 시도하십시오.",
    "wrh-dashboard.cleanup-notification-dialog-box.message.wait": "정리가 아직 백그라운드 모드로 실행되는 중입니다. 정리가 완료될 때까지 기다리십시오.",
    "wrh-dashboard.shared-content-table.column.name": "이름",
    "wrh-dashboard.shared-content-table.column.location": "위치",
    "wrh-dashboard.shared-content-table.column.source": "소스",
    "wrh-dashboard.shared-content-table.column.days": "일",
    "wrh-dashboard.shared-content-table.column.downloads": "다운로드",
    "wrh-dashboard.shared-content-table.column.shared": "공유 위치",
    "wrh-dashboard.shared-content-table.label.shared": "공유 위치",
    "wrh-dashboard.shared-content-table.label.backup": "소스",
    "wrh-dashboard.shared-content-table.action.share": "공유 링크",
    "wrh-dashboard.shared-content-table.action.settings": "링크 설정",
    "wrh-dashboard.shared-content-table.action.delete": "링크 삭제",
    "wrh-dashboard.shared-content-table.action.delete-selected": "링크 삭제",
    "wrh-dashboard.account-page.message.used-space": "{brandName}: {spaceFree} / {totalSpace} 남음",
    "wrh-dashboard.account-page.message.used-unlimited-space": "{brandName}: 무제한 공간",
    "wrh-dashboard.account-page.button.sign-out": "로그아웃",
    "wrh-dashboard.account-page.button.clean-up": "정리",
    "wrh-dashboard.account-page.button.manage-subscription": "라이센스 관리",
    "wrh-dashboard.account-page.message.subscription.active": "{brandName} 공간에 대한 사용자의 라이센스 만료일:",
    "wrh-dashboard.account-page.message.subscription.trial": "{brandName} 평가판 활성화 종료일:",
    "wrh-dashboard.account-page.message.subscription.expired": "{brandName} 공간에 대한 사용자의 라이센스 만료일:",
    "wrh-dashboard.account-page.message.worm-status.storage-full": "{brandName} 스토리지가 가득 찼습니다. 클라우드에 데이터를 백업하거나 아카이브할 수 없습니다.",
    "wrh-dashboard.account-page.message.worm-status.less-than": "남은 공간이 {percent}% 미만입니다. 곧 {brandName}을(를) 사용할 수 없게 됩니다.",
    "wrh-dashboard.notary.verify.view.status.downloading": "다운로드 중...",
    "wrh-dashboard.notary.verify.view.status.validating": "유효성 검사 중...",
    "wrh-dashboard.notary.verify.view.status.pending": "보류 중인 인증서...",
    "wrh-dashboard.notary.verify.view.status.fail": "인증서 불일치...",
    "wrh-dashboard.notary.verify.view.button.get-crt": "인증서 가져오기",
    "wrh-dashboard.notary.verify.view.file-info.name": "이름",
    "wrh-dashboard.notary.verify.view.file-info.signed-by": "서명인",
    "wrh-dashboard.notary.verify.view.file-info.date-backed-up": "백업된 날짜:",
    "wrh-dashboard.notary.verify.view.file-info.date-notarized": "공증된 날짜",
    "wrh-dashboard.notary.verify.view.button.cancel": "취소",
    "wrh-dashboard.notary.verify.view.button.done": "완료",
    "wrh-dashboard.notary.warning.unsupported.browser.version": "지원되지 않는 브라우저 버전",
    "wrh-dashboard.versions-dialog-box.title": "{fileName} 버전",
    "wrh-dashboard.asign-dialog-box.title": "서명을 위해 전송",
    "wrh-dashboard.asign-dialog-box.message": "파일 버전이 공유되었지만 파일 링크가 없으면 아무도 검토할 수 없습니다. ASign을 계속 진행해 서명인을 추가하고 링크를 공유하십시오.",
    "wrh-dashboard.asign-dialog-box.button.show-signed-file-details": "상세정보 표시",
    "wrh-dashboard.shared-link-dialog-box.share-view.button.copy": "링크 복사",
    "wrh-dashboard.shared-link-dialog-box.share-view.button.manage": "링크 설정",
    "wrh-dashboard.shared-link-dialog-box.share-view.message": "이 링크를 사용하는 모두가 최근 버전의 데이터를 볼 수 있습니다.",
    "wrh-dashboard.shared-link-dialog-box.share-view.label.shared": "{creationDate}에서 공유됨",
    "wrh-dashboard.shared-link-dialog-box.share-view.notification.link-copied": "링크 복사됨",
    "wrh-dashboard.shared-link-dialog-box.share-view.notification.link-copy-error": "링크 복사 오류",
    "wrh-dashboard.shared-link-dialog-box.delete-view.title": "링크 삭제",
    "wrh-dashboard.shared-link-dialog-box.delete-view.message": "이 링크는 더 이상 아무도 사용할 수 없습니다.",
    "wrh-dashboard.shared-link-dialog-box.delete-selected-view.title": "링크 삭제",
    "wrh-dashboard.shared-link-dialog-box.delete-selected-view.message": "이 링크를 가진 모두에게 링크의 작동이 중단됩니다.",
    "wrh-dashboard.shared-link-dialog-box.manage-view.title": "링크 설정",
    "wrh-dashboard.shared-link-dialog-box.manage-view.button.delete": "링크 삭제",
    "wrh-dashboard.shared-link-dialog-box.manage-view.button.apply": "완료",
    "wrh-dashboard.shared-link-dialog-box.manage-view.input.hint.password": "암호",
    "wrh-dashboard.shared-link-dialog-box.manage-view.button.reset-password": "패스워드 재설정",
    "wrh-dashboard.shared-link-dialog-box.manage-view.caption.password-protection": "비밀번호 보호",
    "wrh-dashboard.shared-link-dialog-box.manage-view.message.protect-by-password": "비밀번호를 사용해 이 링크를 보호하십시오",
    "wrh-dashboard.shared-link-dialog-box.manage-view.caption.expiration": "만료",
    "wrh-dashboard.shared-link-dialog-box.manage-view.caption.download-limits": "다운로드 제한",
    "wrh-dashboard.shared-link-dialog-box.manage-view.label.disable-in:plural": "{splitMarker}일 후 이 링크 비활성화 | {splitMarker}일 후 이 링크 비활성화",
    "wrh-dashboard.shared-link-dialog-box.manage-view.label.disable-after:plural": "{splitMarker}번 다운로드 후 이 링크 비활성화 | {splitMarker}번 다운로드 후 이 링크 비활성화",
    "wrh-dashboard.page-not-found.title": "페이지를 찾을 수 없음",
    "wrh-dashboard.page-not-found.message.main": "찾고 있는 페이지가 없습니다.",
    "wrh-dashboard.page-not-found.message.description": "링크가 오래되었거나 주소를 잘못 입력했을 수 있습니다.",
    "wrh-dashboard.page-not-found.message.error": "오류 코드: 404",
    "wrh-dashboard.server-error.title": "서버가 작동하지 않습니다",
    "wrh-dashboard.server-error.message": "현재 서버를 사용할 수 없습니다. 나중에 다시 시도하십시오.",
    "wrh-dashboard.server-error.message.error": "오류 코드: 500"
};
